<!-- <span *ngIf="this.activateRose" class="rose" (click)="activeRoseF(true)" [class.active]="this.activeRose">
    <span class="rose"></span>
    <a _ngcontent-asr-c332="" href="javascript:;" (click)="activeRoseF(false)" class="close-section small"></a>
    <img src="assets/img/rose.png" alt="">
    <div (click)="nextDirF()" class="switcher-next-dir"></div>
    <span *ngFor="let dir of roseTitleArray" [class.current]="curSceneName === 'scene_' + dir" class="{{ dir }}" (click)="changeDirection(dir)">{{ dir }}</span>
    <span *ngFor="let dir1 of notActiveRoseDirections" class="disabled {{ dir1 }}">{{ dir1 }}</span>
</span> -->

<!-- <span *ngIf="this.activateRose" class="rose-holder" (click)="activeRoseF(true)" [class.active]="this.activeRose">
    <a href="javascript:;" (click)="activeRoseF(false)" class="close-section small"></a>
    <div class="rose" onmouseenter="lAir.play()"  onmouseleave="lAir.stop()">
        <lottie-player id="lAir" class="air-dir-lottie-button" src="https://lottie.host/16941ee5-2302-4d52-82ca-c194e6a94cc2/3mGgVBhvCR.json" background="transparent" speed="1" count="5" loop autoplay></lottie-player>
        <div (click)="nextDirF()" class="switcher-next-dir"></div>
    </div>
    <span *ngFor="let dir of roseTitleArray" [class.current]="curSceneName === 'scene_' + dir" class="{{ dir }}" (click)="changeDirection(dir)">{{ dir }}</span>
    <span *ngFor="let dir1 of notActiveRoseDirections" class="disabled {{ dir1 }}">{{ dir1 }}</span>
</span> -->
<span class="tooltip justDescktop" *ngIf="this.activateRose">{{
    'ANOTHER-LOOK' | translate }}</span>

<span *ngIf="this.activateRose" class="rose-holder active" id="roseWind">
    <!-- <a href="javascript:;" (click)="activeRoseF(false)" class="close-section small"></a> -->
    <div class="rose">
        <!-- <lottie-player id="lAir" class="air-dir-lottie-button" src="https://lottie.host/16941ee5-2302-4d52-82ca-c194e6a94cc2/3mGgVBhvCR.json" background="transparent" speed="1" count="5" loop autoplay></lottie-player> -->
        <div (click)="nextDirF()" class="switcher-next-dir"></div>
    </div>
    <span *ngFor="let dir of roseTitleArray" [class.current]="curSceneName === 'scene_' + dir" class="{{ dir }}" (click)="changeDirection(dir)">{{ dir }}</span>
    <span *ngFor="let dir1 of notActiveRoseDirections" class="disabled {{ dir1 }}">{{ dir1 }}</span>
</span>
